<template>
    <v-container>
        <v-layout row wrap>
            <v-flex xs12 s12 md12>
                <v-treeview
                        v-if="documents.length > 0"
                        :items="documents"
                        v-model="tree"
                        :open="open"
                        activatable
                        item-key="name"
                        open-all
                        :active="activos"
                >
                    <template slot="prepend" slot-scope="{ item, open, leaf }">
                        <v-icon v-if="!item.file">
                            {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                        </v-icon>
                        <v-icon v-else @contextmenu="showFile($event, item.id, item.document)">
                            {{ files[item.file] }}
                        </v-icon>
                    </template>
                    <template slot="label" slot-scope="{ item, open, leaf }">
                        {{ item.name }}
                        <v-btn v-if="item.file" flat :href="BASE + 'sample-order/' + order_id + '/pdf/' + item.document.id + '?token=' + item.document.token + '&download_token=' + download_token" target="_blank"><v-icon>mdi-cloud-download</v-icon></v-btn>
                        <v-btn v-if="item.file" flat :href="BASE + 'sample-order/' + order_id + '/pdf/' + item.document.id + '?preview=true&token=' + item.document.token + '&download_token=' + download_token" target="_blank"><v-icon>desktop_windows</v-icon></v-btn>
                    </template>
                </v-treeview>
                <v-menu
                        v-model="showMenuFile"
                        :position-x="x"
                        :position-y="y"
                        absolute
                        offset-y
                >
                    <v-list>
                        <v-list-tile
                        >
                            <v-btn v-if="showMenuFile" flat block :href="BASE + 'sample-order/' + order_id + '/pdf/' + document.id + '?token=' + document.token + '&download_token=' + download_token" target="_blank"><v-icon left>mdi-cloud-download</v-icon>Download</v-btn>
                        </v-list-tile>
                        <v-list-tile
                        >
                            <v-btn v-if="showMenuFile" flat block :href="BASE + 'sample-order/' + order_id + '/pdf/' + document.id + '?preview=true&token=' + document.token + '&download_token=' + download_token" target="_blank"><v-icon left>desktop_windows</v-icon>Preview</v-btn>
                        </v-list-tile>

                    </v-list>
                </v-menu>
            </v-flex>
        </v-layout>
        <v-snackbar
                v-model="snackbar"
                multi-line=""
                top
                vertical=""
        >
            {{ text }}
            <v-btn
                    color="pink"
                    flat
                    @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>
        <br>
        <CommentComponent :sample="sample"></CommentComponent>
    </v-container>
</template>

<script>
    import CommentComponent from './components/CommentComponent';
    import { API_BASE } from  '../../../../../src/config.js';
    import { BASE } from "../../../../../src/config";

    export default {
        props: ['order_id', 'sample'],
        data: function () {
            return {
                documents: [],
                API_BASE: API_BASE,
                BASE: BASE,
                open: ['public'],
                files: {
                    html: 'mdi-language-html5',
                    js: 'mdi-nodejs',
                    json: 'mdi-json',
                    md: 'mdi-markdown',
                    pdf: 'mdi-file-pdf',
                    png: 'mdi-file-image',
                    txt: 'mdi-file-document-outline',
                    xls: 'mdi-file-excel'
                },
                tree: [],
                showMenuFolder: false,
                showMenuFile: false,
                x: 0,
                y: 0,
                folder_id: null,
                document: null,
                dialog_create: false,
                dialog_rename: false,
                dialog_upload: false,
                folder_name: '',
                snackbar: false,
                text: 'Hello, I\'m a snackbar',
                download_token: null,
                activos: []
            }
        },
        components: {
            CommentComponent
        },
        created () {
            this.checkUser();
            this.getDocuments();
        },
        methods: {
            checkUser() {
                this.$store.dispatch('checkAccessToken').then((res) => {
                    this.download_token = this.$store.getters.getUser.download_token;
                }).catch((error) => {

                });
            },
            getDocuments () {
                this.$store.dispatch('getDirectoriesFtn', {
                    order_id: this.order_id
                }).then((res) => {
                    this.documents = res.data.data;
                    this.dialog_rename = false;
                    this.dialog_create = false;
                    this.dialog_upload = false;
                    this.showMenuFolder = false;
                    this.showMenuFile = false;
                }).catch((error) => {

                });
            },
            showFile (e, folder_id, document) {
                e.preventDefault()
                this.showMenuFile = false
                this.x = e.clientX
                this.y = e.clientY
                this.$nextTick(() => {
                    this.showMenuFile = true;
                    this.folder_id = folder_id;
                    this.folder_name = '';
                    this.document = document;
                })
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/samples/views/ShipmentComponent.vue